import { Button } from "@/components/shared/Button/Button";
import { Tags } from "@/assets/icons/Tags";
import Search from "@/assets/icons/Search";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

interface NoProductsProps {
  variant?: 'no-products' | 'no-results';
  emptyTitle?: string;
  emptyDescription?: string;
  hasButton?: boolean;
}

export function NoProducts({
  variant = 'no-products',
  emptyTitle,
  emptyDescription,
  hasButton,
}: NoProductsProps) {
  const { t } = useTranslation('common');
  const navigate = useNavigate();

  const content = {
    'no-products': {
      icon: <Tags />,
      title: emptyTitle ?? t('createFirstProduct'),
      description: emptyDescription ?? t('createFirstProductDescription'),
      buttonText: t('btnProductor'),
      buttonAction: () => navigate('/products/create-products'),
    },
    'no-results': {
      icon: <Search />,
      title: t('noProducts'),
      description: t('noProductsDescription'),
      buttonText: null,
      buttonAction: null,
    },
  };

  const currentContent = content[variant];

  return (
    <div
      data-cy='no-results'
      className='flex mt-20 flex-col items-center justify-center text-center space-y-4 '
    >
      <div className='flex flex-col items-center max-w-[328px]'>
        {currentContent.icon}
        <h1 className='text-xl font-semibold text-white mt-4'>
          {currentContent.title}
        </h1>
        <p className='text-[#A1A1AA] mt-2'>{currentContent.description}</p>
      </div>
      {currentContent.buttonText && hasButton && (
        <Button variant='primary' onClick={currentContent.buttonAction}>
          {currentContent.buttonText}
        </Button>
      )}
    </div>
  );
};